<script setup lang="ts">
import { useRouter } from 'vue-router';
import { Home } from '@ilteducation/games';
import { useLocalisation } from '@/plugins/translation';
import GamesBackButton from '@/components/games/GamesBackButton.vue';

// Load Quizter translations from the Quizter Lokalise project
const { includeAdditionalProject } = useLocalisation();
includeAdditionalProject('Quizter', false);

const router = useRouter();

const goToCreate = () => router.push({ name: 'QuizterCreatePage' });
const goToMy = () => router.push({ name: 'QuizterMyPage' });
const goToShared = () => router.push({ name: 'QuizterSharedWithMePage' });
const goBack = () => router.push({ name: 'Games' });
</script>

<template>
  <Home @go-create="goToCreate" @go-my="goToMy" @go-shared="goToShared" @go-back="goBack" />
  <GamesBackButton />
</template>

<style scoped lang="scss"></style>
